import React, { useMemo, useState } from "react";
import "./HorizontalDatePicker.css";

const parseDate = (dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const formatDateTab = (date) => {
  return date
    .toLocaleDateString("es-ES", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    })
    .replace(".", "")
    .toUpperCase();
};

const formatISO = (date) => {
  return date.toISOString().split("T")[0];
};

const HorizontalDatePicker = ({
  startDate,
  endDate,
  allowedDays = [0, 1, 2, 3, 4, 5, 6],
  onSelect,
}) => {
  const [selected, setSelected] = useState(null);

  const dates = useMemo(() => {
    const start = parseDate(startDate);
    const end = parseDate(endDate);
    const list = [];
    const current = new Date(start);

    while (current <= end) {
      if (allowedDays.includes(current.getDay())) {
        list.push(new Date(current));
      }
      current.setDate(current.getDate() + 1);
    }

    return list;
  }, [startDate, endDate, allowedDays]);

  const handleSelect = (date) => {
    const iso = formatISO(date);
    setSelected(iso);
    onSelect && onSelect(iso);
  };

  return (
    <div className="date-container">
      {dates.map((item) => {
        const iso = formatISO(item);
        const isSelected = selected === iso;

        return (
          <button
            key={iso}
            className={`day-tab ${isSelected ? "selected" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleSelect(item);
            }}
          >
            {formatDateTab(item)}
          </button>
        );
      })}
    </div>
  );
};

export default HorizontalDatePicker;
